module.exports = "/lucky-balls/img/jackpot/006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/006.png
// module id = 1106
// module chunks = 0